import React from 'react';
import { values, isNumber } from 'lodash'
import { 
  Table, ButtonGroup, Glyphicon
} from 'react-bootstrap';
import { connect } from 'react-redux' 
import { browserHistory } from 'react-router'
import moment from 'moment'
import DocumentTitle from "react-document-title"

import { createBlock, removeBlock } from '../ducks/blocks'
import AdminNav from '../components/AdminNav.jsx'
import { docListStyle } from '../containers/PageStyles'
import { getRouteLength } from '../../lib/TripTools.js'
import Button from '../components/Button.jsx'
import isObjectEqual from '../../lib/isObjectEqual.js'
import { getBlocks, getFromQuery, getAllRoutes } from '../selectors'
import { replaceQuery } from '../lib/AppTools.js'
import { l } from '../../lib/Tools.js'
import { getText, getTextWithTokens, getLocale } from '../lib/text.js'

/**
 * 
 */
const _s = x => ((x && `${x}`) || " ")
const _c = (x, y) => (isNumber(x) && isNumber(y) ? x - y : _s(x).localeCompare(_s(y)))

function sortBlocks(list: Object[], col: string, direction: "ASC"|"DESC"|"NONE") {
  const comp = (
    direction === "ASC" ? ((a, b) => (
      _c(a[col], b[col]) || (_s(a.name)).localeCompare(_s(b.name))
    ))
    : direction === "DESC" ? ((a, b) => (
      _c(b[col], a[col]) || (_s(a.name)).localeCompare(_s(b.name))
    ))
    : ((a, b) => (_s(a.name)).localeCompare(_s(b.name)))
  )
  return list.sort(comp)
}

/**
 * 
 */
const renderDate = x => (x ? moment(x).locale(getLocale()).fromNow() : "-")


/**
 * 
 */
type BlocksPageProps = {
  blocks: Object, 
  routes: Object, 
  create: Function, 
  remove: Function, 

  query: {
    search: ?string, 
    sortColumn: ?string, 
    sortDirection: "ASC"|"DESC"
  }
}

class BlocksPage extends React.PureComponent
{
  props: BlocksPageProps;

  open(id) {
    browserHistory.push(`/private/block/${encodeURIComponent(id)}`) 
  }
  
  remove(id) {
    this.props.remove(id) 
  }
  
  createBlock() {
    const name = prompt(getText("Nombre de la plantilla"))
    if (name) this.props.create(name, id => this.open(id))
  }

  handleSort(sortColumn) {
    if (sortColumn === this.props.query.sortColumn) {
      replaceQuery(browserHistory, this.props.query, { 
        sortDirection: this.props.query.sortDirection === "ASC" ? "DESC" : "ASC" 
      })
    }
    else {
      replaceQuery(browserHistory, this.props.query, { 
        sortColumn, 
        sortDirection: (sortColumn === "creation" || sortColumn === "modification" ? "DESC" : "ASC")
      })
    }
  }

  handleFilter(search) {
    replaceQuery(browserHistory, this.props.query, { search })
  }

  render() {
    if (!this.props.blocks || !this.props.routes) {
      return (<div>Loading...</div>)
    }
    
    const { sortColumn, sortDirection } = this.props.query

    const ulist = values(this.props.blocks)
    .map(b => ({
      name: b.name, 
      title: b.title, 
      note: b.note, 
      creation: b.creation, 
      modification: b.modification, 
      days: this.props.routes[b.route] ? getRouteLength(this.props.routes[b.route]) : 0,  
      _id: b._id, 
    }))
    const list = sortBlocks(ulist, sortColumn, sortDirection)
    

    const newButton = (
      <Button 
        onClick={() => this.createBlock()}
        glyph="plus"
        style={{marginRight: 5, marginTop: 5, marginBottom: 5}}
      >
        {getText("Nueva plantilla")}
      </Button>
    )

    const MyTh = ({label, col}) => (
      <th 
        onClick={() => this.handleSort(col)} 
        style={{ textDecoration: sortColumn === col ? "underline" : "none", cursor: "pointer" }}
      >
        <Glyphicon glyph="sort" />{label}
      </th>
    )


    const table = (
      <Table bordered striped >
        <thead
          style={{ height: 35, position: "sticky", top: 38, background: "white", zIndex: 20 }}
        >
          <tr>
            <th />
            <MyTh col="days" label={getText("Días")} />
            <MyTh col="name" label={getText("spanish_name")} />
            <MyTh col="name" label={getText("Título")} />
            <th>{getText("Nota")}</th>
            <MyTh col="creation" label={getText("Creación")} />
            <MyTh col="modification" label={getText("Modificación")} />
          </tr>
        </thead>
        <tbody>
          {
            list.map(block => (
              <tr key={block._id}>
                <td style={{width: 95}}>
                  <ButtonGroup>
                    <Button 
                      bsSize="xsmall"
                      style={{color: "red"}}
                      glyph="remove"
                      onClick={() => {
                        if (confirm(getTextWithTokens("delete_block", [block.name]))) 
                          this.remove(block._id) 
                        }}
                    />
                    <Button 
                      bsSize="xsmall"
                      glyph="pencil"
                      onClick={() => this.open(block._id)}
                    >
                      {getText("editButton")}
                    </Button>
                  </ButtonGroup>
                </td>
                <td style={{ width: 40 }}>{block.days}</td>
                <td style={{ width: 200 }}>{block.name}</td>
                <td style={{ width: 100 }}>{block.title}</td>
                <td style={{ width: 150 }}>{block.note}</td>
                <td style={{ width: 80 }}>{renderDate(block.creation)}</td>
                <td style={{ width: 80 }}>{renderDate(block.modification)}</td>
              </tr>
            ))
          }
        </tbody>
      </Table>
    )
    
    return (
      <div 
        id="admin-blocks-list" 
        style={docListStyle()} 
        className="normal" 
      > 
        <DocumentTitle title= {`Tripmaker ${getText("Plantillas")}`} /> 
        <AdminNav active="blocks" />
        <div style={{ zIndex:20, backgroundColor: "white", top: 0, position: "sticky" }}>
          {newButton}
        </div>
        {table}
        <i>({list.length} plantillas)</i>
      </div> 
    )
  }
}

const mapStateToProps = (state, props) => ({
  blocks: getBlocks(state, props), 
  routes: getAllRoutes(state, props), 
  query: {
    search: getFromQuery(state, props)("search") || "",
    sortDirection: getFromQuery(state, props)("sortDirection") || "DESC",
    sortColumn: getFromQuery(state, props)("sortColumn") || "modification"  
  }
})

const mapDispatchToProps = (dispatch) => ({
  create: (name, cb) => dispatch(createBlock({name, title: name, template: true}, cb)),
  remove: id => dispatch(removeBlock(id)), 
})

export default connect(
  mapStateToProps, mapDispatchToProps
)(BlocksPage)
